// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"23648db3","225":"bf366002"}[chunkId] + ".chunk.js";
};